export const displayTypes = ["DROPDOWN", "TEXT"];
export const selectionTypes = ["SINGLE_SELECTION", "MULTIPLE_SELECTION"];
export const sortBy = ["asc", "desc", "none"];
import {
  IFormLookUpConfigurationServer,
  IFormLookUpConfigurationClient,
  IDropdownOption,
  IMapDataActionConfig,
  ILookupSubmissionMapServer,
  IFilterCondition,
  IFilterConditionServer,
  ICustomFilter,
  IFieldValuesMap,
  ICondition,
  IFilterConditionData,
  bulkUpdateSubmissionData,
} from "./interface";
import { IDropdownFieldOptionsClient } from "../FormDropdownField/interface";
import { IFormFieldSubmission } from "@erelego/design-system/interface/Forms/formSubmissionInterface";
import {
  DisplayTypes,
  FieldProps,
  SelectionTypes,
} from "../FormFieldSelector/interfaces";
import _ from "lodash";
import { FormFieldTypes } from "../SelectFieldContainer/formFieldTypesInterface";
import { IFieldsMap } from "@common/redux/formBuilder/interface";
import {
  ILookupResponse,
  ILookupValue,
} from "./Components/ViewFormLookupField";
import {
  IFieldSubmissionMap,
  ILinkedFieldOptions,
} from "@common/redux/formSubmission/interface";
import {
  transformFieldSubmissionValueFromServerToClient,
  transformFieldSubmissionValuesClientToServer,
} from "@common/redux/formSubmission/utils";
import { formFieldInitialSubmissionValues } from "@presentation/FormBuilder/utils";
import { IWidgetFilterSettings } from "@common/redux/forms/interface";
import { DataUtility } from "@utils/DataUtility";
import { IProfileData } from "@common/redux/profile/interface";
import { ConditionType } from "@erelego/design-system/components/molecules/ConditionFilters/utils";
import { IConditionDetails } from "@presentation/GroupedFilterContainer/useGroupFilter";
import {
  IFieldLevelRuleClient,
  IFieldLevelRuleConditionServer,
} from "@presentation/GroupedFilterContainer/interface";
import { IFieldLevelRuleActionServer } from "@presentation/GroupedFilterContainer/FieldRuleValueSelectorComponent/interface";
import { getFieldRuleDataServerFormat } from "@presentation/GroupedFilterContainer/groupedFilterCondition";
import { IUserAttributes } from "@common/redux/admin/interface";
import { allConstraint } from "@presentation/GroupedFilterContainer/FieldRuleValueSelectorComponent/utils";

export const transformLookUpFieldConfigClientToServer = (
  fieldConfigClient: IFormLookUpConfigurationClient
): IFormLookUpConfigurationServer => {
  const {
    sourceForm,
    sourceField,
    referenceLookUp,
    initialValueWithAccessKey,
    displayType,
    selectionType,
    sortType,
    inclusions,
    isDataGridDuplicateDisabled,
    isDataGridLookUpDuplicateDisabledByRows,
    dataGridLookupDuplicateDisabledRowByField,
    logicalOperator,
    filters,
    isPII,
    encryptDetails,
    isQrCodeAllowed,
    writeJavascript,
    lookupFilter,
    isRefrenceToCurrentForm,
    enableMappingInEditMode,
    isPreSelectedValueRequired,
    isRelationshipExist,
    showAddSubmission,
    sortBy,
    isApiTriggerOnClick,
  } = fieldConfigClient;
  const fieldConfigServer = {
    sourceForm: transformOptioncts(sourceForm),
    sourceField: sourceField,
    referenceLookUp: transformOptioncts(referenceLookUp),
    isRelationshipExist: isRelationshipExist,
    initialValueWithAccessKey: initialValueWithAccessKey,
    displayType: displayType,
    selectionType: selectionType,
    sortType: sortType,
    inclusions: inclusions,
    isDataGridDuplicateDisabled: isDataGridDuplicateDisabled,
    isDataGridLookUpDuplicateDisabledByRows,
    dataGridLookupDuplicateDisabledRowByField,
    logicalOperator: logicalOperator,
    filters: convertFilterClientToServerFormat(filters) || [],
    isPII: isPII || false,
    encryptDetails: encryptDetails,
    isQrCodeAllowed: isQrCodeAllowed,
    writeJavascript: writeJavascript,
    lookupFilter: lookupFilter,
    isRefrenceToCurrentForm: isRefrenceToCurrentForm,
    enableMappingInEditMode: enableMappingInEditMode,
    isPreSelectedValueRequired: isPreSelectedValueRequired,
    showAddSubmission: showAddSubmission,
    sortBy: sortBy,
    isApiTriggerOnClick: isApiTriggerOnClick,
  };
  return fieldConfigServer;
};

export const transformLookUpConfigServerToClient = (
  fieldConfigServer: IFormLookUpConfigurationServer
): IFormLookUpConfigurationClient => {
  const {
    sourceForm,
    sourceField,
    referenceLookUp,
    isRelationshipExist,
    initialValueWithAccessKey,
    displayType,
    selectionType,
    sortType,
    inclusions,
    isDataGridDuplicateDisabled,
    isDataGridLookUpDuplicateDisabledByRows,
    dataGridLookupDuplicateDisabledRowByField,
    logicalOperator,
    filters,
    isPII,
    encryptDetails,
    isQrCodeAllowed,
    writeJavascript,
    lookupFilter,
    isRefrenceToCurrentForm,
    enableMappingInEditMode,
    isPreSelectedValueRequired,
    showAddSubmission,
    sortBy,
    isApiTriggerOnClick,
  } = fieldConfigServer;

  const fieldConfigClient = {
    sourceForm: transformOptionstc(sourceForm),
    sourceField: sourceField,
    referenceLookUp: transformOptionstc(referenceLookUp),
    isRelationshipExist: isRelationshipExist,
    initialValueWithAccessKey: initialValueWithAccessKey,
    displayType: displayType,
    selectionType: selectionType,
    sortType: sortType,
    inclusions: inclusions,
    isDataGridDuplicateDisabled: isDataGridDuplicateDisabled,
    isDataGridLookUpDuplicateDisabledByRows,
    dataGridLookupDuplicateDisabledRowByField,
    logicalOperator: logicalOperator,
    filters: convertFilterServerToClientFormat(filters) || [],
    isPII: isPII || false,
    encryptDetails: encryptDetails,
    isQrCodeAllowed: isQrCodeAllowed,
    writeJavascript: writeJavascript,
    lookupFilter: lookupFilter,
    isRefrenceToCurrentForm: isRefrenceToCurrentForm,
    enableMappingInEditMode: enableMappingInEditMode,
    isPreSelectedValueRequired: isPreSelectedValueRequired,
    showAddSubmission: showAddSubmission,
    sortBy: sortBy,
    isApiTriggerOnClick: isApiTriggerOnClick,
  };
  return fieldConfigClient;
};

export const transformOptioncts = (item: IDropdownOption) => {
  return {
    optionKey: item?.value || "",
    optionValue: item?.content || "",
  };
};

export const transformOptionstc = (item: IDropdownFieldOptionsClient) => {
  return {
    content: item?.optionValue || "",
    value: item?.optionKey || "",
  };
};

export const validateLookupFieldSubmissionData = (
  fieldEditConfig: FieldProps,
  fieldSubmissionData: IFormFieldSubmission
): [boolean, string] => {
  const { fieldValue, isVisible, isRequired } = fieldEditConfig;
  const fieldSubmissionValue = fieldSubmissionData?.fieldSubmissionValue;
  const submissionValue = fieldSubmissionValue?.value || "";
  const selectedOptions = fieldSubmissionValue?.selectedOptions || [];
  const selectedOption = fieldSubmissionValue?.selectedOption;
  const displayType = fieldValue.displayType;
  let isNotEmpty: any;
  if (fieldValue.selectionType == SelectionTypes?.MULTIPLE_SELECTION) {
    isNotEmpty = selectedOptions?.length || selectedOption?.length || false;
  } else {
    if (selectedOption) {
      isNotEmpty = !_.isEmpty(selectedOption);
      if (!selectedOption?.optionKey?.length) {
        isNotEmpty = false;
      }
    }
  }

  if (isRequired && !!isVisible) {
    if (!isNotEmpty && displayType == DisplayTypes.DROPDOWN) {
      return [false, "This is a Required Field"];
    } else if (!submissionValue && displayType == DisplayTypes.TEXT) {
      return [false, "This is a Required Field"];
    }
  }
  return [true, ""];
};

export const getFieldSelectOptionForAction = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): any[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title,
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};

export const getFieldToSelectFieldForTable = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToAllow: string[],
  allowedFieldIds: string[]
): any[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      fieldTypesToAllow.includes(fieldType) &&
      allowedFieldIds?.includes(key)
    ) {
      filteredFieldOptions.push({
        content: title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title,
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};

export const getFieldToSelectForTable = (
  fieldsMap: IFieldsMap,
  allowedFieldIds: string[]
): any[] => {
  const filteredFieldOptions: any = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      parentFormId,
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (!checkIsSection && allowedFieldIds?.includes(key)) {
      filteredFieldOptions.push({
        content: title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title,
      });
    }
  });
  return filteredFieldOptions;
};

export const getFieldSubmissionBySubmissionId = (
  lookupResponse: ILookupResponse,
  submissionId: string
) => {
  const resultObject = {};
  for (const fieldId in lookupResponse) {
    if (Object.hasOwnProperty.call(lookupResponse, fieldId)) {
      const submissionValues = lookupResponse[fieldId];
      if (submissionId in submissionValues) {
        resultObject[fieldId] = submissionValues[submissionId];
      }
    }
  }
  return resultObject;
};

let previousValue = "";
export const updateBulkSubmissionValueForLookup = (
  fieldSubmissionMap: IFieldSubmissionMap,
  mapFieldsValue: IMapDataActionConfig[],
  submissionValues: any,
  fieldsMap: IFieldsMap,
  subId?: string,
  formId?: string,
  fieldsToHide?: string[],
  pageToHide?: string[],
  columnId?: string,
  lookupResponse?: any,
  currentLinkedFieldSubmissionValue?: ILinkedFieldOptions
): bulkUpdateSubmissionData => {
  let updatedLinkedSubmissionValue = { ...currentLinkedFieldSubmissionValue };
  const fieldSubmissionData: IFormFieldSubmission[] = [];
  mapFieldsValue?.forEach((mapValue: IMapDataActionConfig) => {
    const fromFieldId = mapValue?.fromFieldId;
    const toFieldId = mapValue?.toFieldId;
    const toFieldIdType = fieldsMap[toFieldId]?.fieldType;
    const dataGridField =
      !submissionValues[fromFieldId] &&
      Object.values(fieldsMap).filter((elem) => elem.fieldType == "DATA_GRID");
    const isfieldInsideDatagrid =
      dataGridField[0]?.fields?.includes(fromFieldId);

    const fromFieldSubmissionValue =
      fromFieldId == "submissionId"
        ? subId
        : isfieldInsideDatagrid
          ? ""
          : submissionValues[fromFieldId];

    let toFieldSubmissionData: IFormFieldSubmission =
      fieldSubmissionMap[toFieldId];
    const toFieldData: FieldProps = fieldsMap[toFieldId];
    if (!toFieldSubmissionData) {
      toFieldSubmissionData = formFieldInitialSubmissionValues(
        toFieldId,
        toFieldData
      );
    }

    if (fromFieldSubmissionValue != null || fromFieldSubmissionValue !== undefined) {
      const updatedSubmissionValue =
        transformFieldSubmissionValueFromServerToClient(
          toFieldSubmissionData?.fieldType,
          fromFieldSubmissionValue,
          formId,
          fieldsToHide,
          pageToHide,
          fieldsMap,
          subId
        );
      const fieldType = toFieldSubmissionData?.fieldType;
      if (fieldType == FormFieldTypes?.DROPDOWN) {
        updatedLinkedSubmissionValue = updateFieldValue(
          updatedLinkedSubmissionValue,
          fieldType as FormFieldTypes,
          toFieldId,
          fromFieldSubmissionValue
        );
        return;
      }
      if (fieldType == FormFieldTypes?.CURRENCY) {
        if (previousValue === fromFieldSubmissionValue) {
          return;
        }
        previousValue = fromFieldSubmissionValue;
      }
      const updatedToFieldSubmissionData: IFormFieldSubmission = {
        ...toFieldSubmissionData,
        fieldSubmissionValue: updatedSubmissionValue,
        ...(columnId && { columnId }),
      };

      fieldSubmissionData.push(updatedToFieldSubmissionData);
    }
  });

  return {
    submissionData: fieldSubmissionData ?? [],
    linkedFieldSubmissionValue: updatedLinkedSubmissionValue ?? {},
  };
};

export const transformLookupSubmissionServerToCLient = (
  lookupSubmissionServer: ILookupSubmissionMapServer
) => {
  const lookupSubmissionClient: ILookupValue = {};
  for (const fieldId in lookupSubmissionServer) {
    if (Object.hasOwnProperty.call(lookupSubmissionServer, fieldId)) {
      const submissions = lookupSubmissionServer[fieldId];
      lookupSubmissionClient[fieldId] = {};

      submissions.forEach((submission) => {
        const submissionId = submission.submission_id;
        const submissionValue = submission.submission_value;
        lookupSubmissionClient[fieldId][submissionId] = submissionValue;
      });
    }
  }
  return lookupSubmissionClient;
};

export const convertJsonNewToOutputJson = (submissions: any) => {
  const extractedData = {};
  submissions?.forEach((item) => {
    for (const fieldId in item?.formData) {
      if (!extractedData?.[fieldId]) {
        extractedData[fieldId] = {};
      }
      const value = item?.formData?.[fieldId];
      const submissionId = item?.id;
      if (Array.isArray(value)) {
        extractedData[fieldId][submissionId] = value || [];
        // If the value is an array, extract array of optionKey and optionValue
      } else if (typeof value === "object") {
        // If the value is an object, extract optionKey and optionValue
        extractedData[fieldId][submissionId] = {
          optionKey: value?.optionKey,
          optionValue: value?.optionValue,
        };
      } else {
        // If the value is not an object, store it directly
        extractedData[fieldId][submissionId] = value;
      }
    }
  });

  return extractedData;
};

function convertFilterClientToServerFormat(
  conditions: IFilterCondition[]
): IFilterConditionServer[] {
  return conditions?.map((condition) => {
    const { value, ...rest } = condition;
    return {
      ...rest,
      value: typeof value === "object" ? undefined : String(value),
      fieldValue: typeof value === "object" ? value : undefined,
    };
  });
}

// Function to convert array of IFilterConditionServer to array of IFilterCondition
function convertFilterServerToClientFormat(
  conditionsServer: IFilterConditionServer[]
): IFilterCondition[] {
  return conditionsServer?.map((conditionServer) => {
    const { value, fieldValue, ...rest } = conditionServer;
    return conditionServer;
    return {
      ...rest,
      value: value || fieldValue || "",
    };
  });
}

export interface IQueryToFilterLookup {
  formId: string;
  filter: { [key: string]: any };
}
const OptionsFieldType = ["LOOKUP", "DROPDOWN"];

export const stringifyFIlter = (
  filterCondition: IFilterCondition[],
  formId: string,
  logicalOperator = "OR",
  fieldSubmissionMap
): IQueryToFilterLookup => {
  const queryFilter = {};
  filterCondition?.forEach((item: IFilterCondition) => {
    let value; //parseString(item.value)
    if (item?.fieldValueType == "form_field" || item?.value?.value) {
      const submisionData = fieldSubmissionMap[item?.value?.value];
      if (submisionData?.fieldSubmissionValue) {
        const TransformedValue = transformFieldSubmissionValuesClientToServer(
          submisionData?.fieldType,
          submisionData?.fieldSubmissionValue
        );
        if (
          submisionData?.fieldType == "NUMBER_INPUT" ||
          submisionData?.fieldType == "PIN_CODE"
        ) {
          value = parseString(TransformedValue);
        } else if (OptionsFieldType.includes(item?.fieldType)) {
          value = {
            optionKey: "",
            optionValue:
              TransformedValue?.optionValue ||
              TransformedValue?.selectedOption ||
              TransformedValue ||
              "",
          };
        } else {
          value = TransformedValue?.selectedOption || TransformedValue || "";
        }
      }
    } else {
      value = item.value;
    }
    if (value) {
      queryFilter[item?.fieldLocalId] = value;
    }
  });

  return {
    formId: formId,
    filter: queryFilter,
  };
};

const parseString = (input) => {
  const numericValue = parseFloat(input);
  if (!isNaN(numericValue) && isFinite(numericValue)) {
    return numericValue;
  } else {
    return input;
  }
};

export const getFieldIdToMonitor = (
  filterCondition: IFilterCondition[]
): string[] => {
  const fieldIds = [];
  filterCondition?.forEach((item, index) => {
    if (item?.value?.value) {
      fieldIds.push(item?.value?.value);
    }
  });
  return fieldIds;
};

export const checkIfFieldAndSubmissionValuesAreUpdated = (
  oldFieldSubmissionMap,
  newFieldSubmissionMap,
  localIds,
  fieldDataPrevState,
  fieldData
) => {
  for (const localId of localIds) {
    const oldSubmission = oldFieldSubmissionMap?.[localId];
    const newSubmission = newFieldSubmissionMap?.[localId];
    if (oldSubmission && newSubmission) {
      if (
        !DataUtility.isEqual(
          oldSubmission?.fieldSubmissionValue,
          newSubmission?.fieldSubmissionValue
        )
      ) {
        return true;
      }
    }
  }
  if (oldFieldSubmissionMap && newFieldSubmissionMap) {
    // remove this if condition later
    if (!DataUtility.isEqual(oldFieldSubmissionMap, newFieldSubmissionMap)) {
      return true;
    }
  }
  if (fieldDataPrevState && fieldData) {
    if (!DataUtility.isEqual(fieldDataPrevState, fieldData)) {
      return true;
    }
  }
  return false;
};
export const checkIfStringExist = (obj, targetString) => {
  return Object.values(obj)?.some((item: any) => item?.value === targetString);
};
const transformArrayToObject = (
  array: ICondition[]
): Record<string, string> => {
  const resultObject: Record<string, string> = {};
  array?.forEach((item) => {
    const { fieldLocalId, value } = item;
    resultObject[fieldLocalId] = value;
  });

  return resultObject;
};
const startsWithDoubleCurlyBraces = (str: string) => {
  return str.startsWith("{{");
};
export const processDynamicValue = (value: string) => {
  if (value.slice(0, 2) === "{{" && value.slice(-2) === "}}") {
    const strippedValue = value.slice(2, -2);
    const resultArray = strippedValue.split(".");
    return resultArray;
  } else {
    return [value];
  }
};
export const convertFilter = (
  customFilter: ICustomFilter,
  profileData: IProfileData,
  fieldValuesMap: IFieldValuesMap
) => {
  const data = transformArrayToObject(customFilter?.condition);

  const obj: { [key: string]: unknown[] } = {};
  const keys = Object.keys(data);
  for (const key of keys) {
    const dataObj = data[key];
    let option: unknown[] = [];
    let isUserData = [dataObj];
    if (startsWithDoubleCurlyBraces(`${dataObj}`)) {
      isUserData = processDynamicValue(dataObj);
    }
    if (isUserData[0] == "user") {
      const updatedKey = isUserData[1] as string;
      if ((profileData as any)[updatedKey] !== undefined) {
        obj[key] = (profileData as any)[updatedKey];
      }
    } else if (isUserData[0] == "data") {
      const updatedKey = isUserData[1] as string;
      if ((fieldValuesMap as any)[updatedKey] != "") {
        obj[key] = (fieldValuesMap as any)[updatedKey];
      }
    } else {
      if (Array.isArray(dataObj)) {
        option = dataObj.map((obj) => {
          if (typeof obj === "object" && "content" in obj && obj.content) {
            const datavalue = obj as { content: string; value: string };
            return {
              optionKey: datavalue.value || null,
              optionValue: datavalue.content,
            };
          } else {
            return obj;
          }
        });
      } else {
        option = [dataObj];
      }
      obj[key] = option;
    }
  }
  return obj;
};
export const getTransferClientToServerConditionData = (
  customFilter: ICustomFilter,
  formId: string,
  profileData: any,
  fieldValuesMap: IFieldValuesMap,
  fieldsMap?: IFieldsMap
): IFilterConditionData => {
  const updatedCondition = [];
  const fieldValues: { [key: string]: unknown[] } = convertFilter(
    customFilter,
    profileData,
    fieldValuesMap
  );
  if (customFilter?.condition) {
    for (const condition of customFilter?.condition) {
      const value: any = fieldValues[condition.fieldLocalId] ?? "";
      const fieldValueType = condition.fieldValueType;
      const contentType = condition.conditionType;
      let updatedValue = Array.isArray(value) ? value[0] : value;
      let updatedLocalId = condition.fieldLocalId;

      // if (
      //   (condition.fieldValueType === "form_field" || contentType == "form_field")
      // ) {
      //   const fieldData: any = fieldValuesMap[condition?.fieldValue.value || condition?.value.value];
      //   const fieldValue = transformFieldSubmissionValuesClientToServer(
      //     fieldData?.fieldType,
      //     fieldData?.fieldSubmissionValue
      //   );
      //   if (Array.isArray(fieldValue)) {
      //     // let concatenatedString = "";
      //     // for (const option of fieldValue) {
      //     //   concatenatedString = concatenatedString + "," + option?.optionValue;
      //     // }
      //     // updatedValue = removeLeadingComma(concatenatedString);
      //     const firstValue = fieldValue?.[0];
      //     updatedValue = firstValue.optionValue;
      //   } else if (typeof fieldValue === "object") {
      //     updatedValue = fieldValue
      //       ? fieldValue.optionValue || ""
      //       : "";
      //   } else {
      //     updatedValue = fieldValue
      //   }
      // } else if (
      //   (condition.fieldValueType === "custom_field")
      // ) {
      //   updatedValue = condition?.value
      // }

      if (Array.isArray(value) && typeof value[0] == "string") {
        updatedValue = value[0] ?? "";
      } else if (
        Array.isArray(value) &&
        value[0] &&
        typeof value[0] == "object" &&
        fieldValueType != ConditionType.user_field &&
        fieldValueType != ConditionType.system_fields
      ) {
        updatedValue = value[0]?.optionValue ?? value[0]?.value ?? "";
      } else if (
        !Array.isArray(value) &&
        typeof value == "object" &&
        fieldValueType != ConditionType.user_field &&
        fieldValueType != ConditionType.system_fields
      ) {
        updatedValue = value?.optionValue ?? value?.value ?? "";
      } else if (
        fieldValueType == ConditionType.user_field ||
        fieldValueType == ConditionType.system_fields ||
        contentType == "user_field"
      ) {
        const getFieldValue = value?.[0]?.value;
        if (contentType == "user_field" && getFieldValue == "userId") {
          updatedLocalId = "_id";
        }
        if (
          getFieldValue == "userId" ||
          getFieldValue == "email" ||
          getFieldValue == "phoneNumber" ||
          getFieldValue == "username"
        ) {
          if (getFieldValue == "username") {
            updatedValue = profileData["name"];
          } else {
            updatedValue = profileData[getFieldValue];
          }
        }
      } else {
        const fieldData: any =
          fieldValuesMap[
          condition?.fieldValue?.value || condition?.value?.value
          ];
        const fieldValue = transformFieldSubmissionValuesClientToServer(
          fieldData?.fieldType,
          fieldData?.fieldSubmissionValue
        );
        if (Array.isArray(fieldValue)) {
          // let concatenatedString = "";
          // for (const option of fieldValue) {
          //   concatenatedString = concatenatedString + "," + option?.optionValue;
          // }
          // updatedValue = removeLeadingComma(concatenatedString);
          const firstValue = fieldValue?.[0];
          updatedValue = firstValue?.optionValue;
        } else if (typeof fieldValue === "object") {
          updatedValue = fieldValue ? fieldValue?.optionValue || "" : "";
        } else {
          updatedValue = fieldValue;
        }
      }
      const fieldType = fieldsMap?.[updatedLocalId]?.fieldType ?? "";
      const updatedConditionValue: ICondition = {
        fieldTitle: condition.fieldTitle,
        fieldLocalId: updatedLocalId,
        condition: condition.condition,
        value: updatedValue,
        fieldValueType: fieldValueType,
        fieldType: fieldType || condition?.fieldType,
        conditionType: contentType,
        logicalOperator: condition.logicalOperator,
      };
      if (updatedValue) {
        updatedCondition.push(updatedConditionValue);
      }
    }
  }
  const filterCondition: IFilterConditionData = {
    formId: formId,
    query: {
      logicalOperator: "OR",
      conditions: updatedCondition,
    },
  };
  return filterCondition;
};

export const removeLeadingComma = (inputString: string) => {
  if (inputString.charAt(0) === ",") {
    // If the first character is a comma, remove it
    return inputString.substring(1);
    // Alternatively, you can use inputString.slice(1);
  }
  return inputString;
};
export interface IFieldLevelRuleServer {
  ruleName?: string;
  logicalOperator?: string;
  conditions?: IFieldLevelRuleConditionServer[];
  action?: IFieldLevelRuleActionServer;
}
export const getUpdatedConditionData = (
  fieldConditionDataState: IConditionDetails
): IFieldLevelRuleServer[] => {
  const fieldRules = fieldConditionDataState.fieldRules;
  const fieldConditionMap = fieldConditionDataState.fieldConditionMap;
  const fieldRulesServer: IFieldLevelRuleServer[] = [];
  fieldRules?.forEach((fieldRuleClient: IFieldLevelRuleClient) => {
    const fieldRuleServer: IFieldLevelRuleServer = getFieldRuleDataServerFormat(
      fieldRuleClient,
      fieldConditionMap ?? {}
    );
    fieldRulesServer.push(fieldRuleServer);
  });
  return fieldRulesServer;
};
const separator = "__LOOKUP_SEPARATOR__";
export const sepratorRegex = new RegExp(`^(.+)${separator}(.+)$`);

export const extractAttribute = (
  input: string
): { key: string; value: string } | null => {
  const match = input?.match(/\{\{(\w+)\.(\w+)\}\}/);
  if (match) {
    const [, key, value] = match;
    return { key, value };
  }
  return null;
};
const enum InitialValueEnums {
  userAttributes = "userAttributes",
}
export const getInitialValueData = (
  value: string,
  userAttributes: IUserAttributes
) => {
  let initialValue = "";
  const extractKeyValue = extractAttribute(value);
  if (extractKeyValue?.key == InitialValueEnums.userAttributes) {
    initialValue = userAttributes?.[extractKeyValue?.value]?.[0] ?? "";
  }
  return initialValue;
};

export const updateFieldValue = (
  obj: ILinkedFieldOptions,
  fieldType: FormFieldTypes,
  fieldId: string,
  submissionValue: any
) => {
  if (!obj[fieldType]) {
    obj[fieldType] = {};
  }
  if (!obj[fieldType][fieldId]) {
    obj[fieldType][fieldId] = submissionValue;
  } else {
    obj[fieldType][fieldId] = submissionValue;
  }

  return obj;
};

const operatorsWithoutValue: string[] = [
  allConstraint.IS_EMPTY,
  allConstraint.IS_NOT_EMPTY,
];

const isConditionValuePresent = (
  condition: IFieldLevelRuleConditionServer
): boolean => {
  if (condition?.valueAsList?.length) return true;
  const value: any = condition?.value;
  if (value === undefined || value === null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  return true;
};

export const areLookupFilterValuesPresent = (
  conditions: IFieldLevelRuleConditionServer[]
): boolean => {
  return (conditions ?? []).every((condition) => {
    if (
      condition?.conditions?.length &&
      !areLookupFilterValuesPresent(condition.conditions)
    ) {
      return false;
    }
    if (!condition?.operator || operatorsWithoutValue.includes(condition.operator)) {
      return true;
    }
    return isConditionValuePresent(condition);
  });
};
